import React from 'react';
import './get-toastie-dialog.css';

interface GetToastieDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

export const GetToastieDialog: React.FC<GetToastieDialogProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;
  const qr = `${process.env.PUBLIC_URL}/assets/appDownload/QR.png`;

  return (
    <div className="dialog-overlay" onClick={onClose}>
      <div className="dialog-content" onClick={e => e.stopPropagation()}>
        <button className="dialog-close" onClick={onClose}>×</button>
        <h3>Download Toastie</h3>
        <img
          src={qr}
          alt="Download the app"
          className="qr"
        />
      </div>
    </div>
  );
};
